import { Box, CircularProgress } from '@mui/material';
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAPI } from 'src/api/provider';
import { StringParam, useQueryParam } from 'src/helpers/queryParam';
import { InvalidMagicLink } from './InvalidMagicLink';
import { buildPostMagicLinkUrl } from './magicLinkUrl';

const ConsumingMagicLink = () => {
    const { t } = useTranslation('auth.magicLink');
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
            style={{ minHeight: '100vh' }}
        >
            <CircularProgress size={100} />
            <Box my={4}>{t('processingLoginLink')}</Box>
        </Grid>
    );
};

export const MagicLinkConsumer = ({ children }: { children: React.ReactNode }) => {
    const apiClient = useAPI();

    const [loginFailed, setLoginFailed] = useState(false);
    const [username] = useQueryParam('username', StringParam);
    const [token] = useQueryParam('magic_link_token', StringParam);

    useEffect(() => {
        if (!token) {
            return;
        }
        (async () => {
            try {
                await apiClient.post('/magic-link-login/', { token });
                window.location.replace(
                    buildPostMagicLinkUrl({
                        pathname: window.location.pathname,
                        search: window.location.search,
                        hash: window.location.hash,
                    }),
                );
            } catch {
                setLoginFailed(true);
            }
        })();
    }, [apiClient, token]);

    if (token) {
        return loginFailed ? (
            <InvalidMagicLink initialUsername={username || ''} />
        ) : (
            <ConsumingMagicLink />
        );
    }

    return <>{children}</>;
};
